import { useStore } from "ra-core";

import { TODAS, type FiltroPersona } from "../dominio/equipo";

/**
 * Filtro «de quién» del Pipeline y la Agenda (Robert, 07/10/2026: «en nuestro panel todos
 * los leads, con el nombre del propietario, y poder filtrar por las fichas de cada
 * persona»). Solo para administradores: un setter ya ve solo lo suyo. Se recuerda por
 * pantalla en el store de ra-core.
 */
export const useFiltroPersona = (pantalla: string) =>
  useStore<FiltroPersona>(`nevora.${pantalla}.persona`, TODAS);
